import React from 'react';
import { FaCalculator } from 'react-icons/fa';

const TotalSquareFootage = ({ shapes, mergedStructures }) => {
  const calculateTotalSquareFootage = () => {
    let total = 0;

    // Calculate from individual shapes
    if (shapes && Array.isArray(shapes)) {
      shapes.forEach(shape => {
        if (shape.type === 'rectangle' && shape.width && shape.height) {
          // Convert from pixels to square feet (assuming 100 pixels = 1 foot)
          const squareFeet = (shape.width * shape.height) / 10000;
          total += squareFeet;
        }
      });
    }

    // Calculate from merged structures
    if (mergedStructures && Array.isArray(mergedStructures)) {
      mergedStructures.forEach(structure => {
        if (structure.shapes && Array.isArray(structure.shapes)) {
          structure.shapes.forEach(shape => {
            if (shape.width && shape.height) {
              const squareFeet = (shape.width * shape.height) / 10000;
              total += squareFeet;
            }
          });
        }
      });
    }

    return total;
  };

  const totalSquareFootage = calculateTotalSquareFootage();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #404040 100%)',
        border: '2px solid #333',
        borderRadius: '12px',
        padding: '12px 20px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        zIndex: 1000,
        minWidth: '200px',
        justifyContent: 'center'
      }}
    >
      <FaCalculator style={{ fontSize: '18px' }} />
      <span>Total: {totalSquareFootage.toFixed(1)} sq ft</span>
    </div>
  );
};

export default TotalSquareFootage; 